/**
 * Public website module — "Planning Applications". Same postcode search
 * tool as the agent dashboard (PlanningApplicationsTool, in publicMode so
 * it hits the unauthenticated /api/public/planning-applications/search
 * endpoint and hides the agent-only "Near your properties" section),
 * plus a configurable CTA button linking to any site page.
 */
import PlanningApplicationsTool from "@/components/property-admin/PlanningApplicationsTool";

function ctaHref(slug) {
  if (slug === null || slug === undefined || slug === "") return null;
  return slug.startsWith("/") ? slug : `/${slug}`;
}

export default function PlanningApplicationsModule({ config = {} }) {
  const href = ctaHref(config.cta_page_slug);
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 space-y-6" data-testid="planning-applications-public-module">
      <div className="text-center space-y-2">
        {config.heading && (
          <h2 className="text-2xl sm:text-3xl font-serif font-medium" data-testid="planning-applications-module-heading">
            {config.heading}
          </h2>
        )}
        {config.subheading && (
          <p className="text-muted-foreground" data-testid="planning-applications-module-subheading">
            {config.subheading}
          </p>
        )}
      </div>

      <PlanningApplicationsTool publicMode />

      {config.cta_text && href && (
        <div className="text-center pt-2">
          <a
            href={href}
            className="inline-flex items-center justify-center gap-2 font-semibold transition-all duration-200 shadow hover:shadow-lg hover:-translate-y-0.5 whitespace-nowrap px-8 py-4 text-lg"
            style={{
              backgroundColor: "var(--button-bg, var(--primary, #2f4f4f))",
              color: "var(--button-text, #ffffff)",
              borderRadius: "999px",
            }}
            data-testid="planning-applications-module-cta"
          >
            {config.cta_text}
          </a>
        </div>
      )}
    </div>
  );
}
